import AILawyer from "./sections/AILawyer";
import Deploy from "./sections/Deploy";
import Facilities from "./sections/Facilities";
import FirstSection from "./sections/FirstSection";
import Frequent from "./sections/Frequent";
import MoreInfo from "./sections/MoreInfo";
import Professors from "./sections/Professors";
import QuickAccess from "./sections/QuickAccess";

const Section = () => {
  return (
    <>
      <div className="w-full sm:w-[95%] relative my-2 border border-stroke1 md:w-[80%] xl:w-[75%] txl:w-[65%] mb-14">
        <FirstSection />
        <MoreInfo />
        <Frequent />
        <AILawyer />
        <Facilities />
        <Deploy />
        <Professors />
        <QuickAccess />
      </div>
    </>
  );
};

export default Section;
